{
  "sdk-download-android": "Stiahnuť pre Android",
  "sdk-connect": "Pripojiť",
  "sdk-download-ios": "Stiahnuť pre iOS",
  "sdk-install": "Nainštalovať",
  "sdk-modal-instruct-1": "1. Otvorte aplikáciu Binance",
  "sdk-modal-instruct-2": "2. Klepnite na ikonu {{icon}} na domovskej obrazovke",
  "sdk-modal-title": "Spojte sa s Binance",
  "sdk-no-app": "Ešte nemáte aplikáciu Binance?"
}